<template>
  <b-navbar
    toggleable="lg"
    type="dark"
    variant="exitos"
    class="d-none d-md-flex"
  >
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-button class="btn btn-sm btn-secondary text-exitos d-none">
          <font-awesome-icon icon="plus" />
          Nova Oportunidade
        </b-button>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-form class="d-none">
          <b-form-input
            size="sm"
            class="mr-sm-2"
            placeholder="Pesquisar"
          ></b-form-input>
          <b-button size="sm" class="my-2 my-sm-0" type="submit"
            >Busca rápida</b-button
          >
        </b-nav-form>
      </b-navbar-nav>
    </b-collapse>
    <User />
  </b-navbar>
</template>
<script>
import User from "@/components/SidebarPlugin/User.vue";
export default {
  components: { User },
};
</script>
